"use strict";
export function getQuarter(month) {
  return Math.floor((month - 1) / 3) + 1;
}
export function getQuarterMonthRange(quarter) {
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
  const startMonthIndex = (quarter - 1) * 3;
  const endMonthIndex = startMonthIndex + 2;
  return {
    startMonth: monthNames[startMonthIndex],
    endMonth: monthNames[endMonthIndex]
  };
}
export function formatQuarterLabel(quarter, year) {
  const { startMonth, endMonth } = getQuarterMonthRange(quarter);
  const shortYear = year.toString().slice(-2);
  return `${startMonth} - ${endMonth} '${shortYear}`;
}
export function formatMonthlyLabel(month, year) {
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
  const monthName = monthNames[month - 1];
  const shortYear = year.toString().slice(-2);
  return `${monthName} '${shortYear}`;
}
export function getLastNQuarters(n) {
  const result = [];
  const now = /* @__PURE__ */ new Date();
  let year = now.getFullYear();
  let quarter = getQuarter(now.getMonth() + 1);
  for (let i = 0; i < n; i++) {
    result.push({ year, quarter });
    quarter--;
    if (quarter === 0) {
      quarter = 4;
      year--;
    }
  }
  return result.reverse();
}
export const sortLabelsChronologically = (labels) => {
  return labels.sort((a, b) => {
    if (a.includes(" - ") && b.includes(" - ") && a.includes("'") && b.includes("'")) {
      const yearA = parseInt(a.split("'")[1] || "0");
      const yearB = parseInt(b.split("'")[1] || "0");
      if (yearA !== yearB) return yearA - yearB;
      const getQuarterFromLabel = (label) => {
        const startMonth = label.split(" - ")[0];
        const monthNames = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ];
        const monthIndex = monthNames.indexOf(startMonth);
        return Math.floor(monthIndex / 3) + 1;
      };
      return getQuarterFromLabel(a) - getQuarterFromLabel(b);
    }
    if (a.includes("'") && b.includes("'") && !a.includes(" - ") && !b.includes(" - ")) {
      const yearA = parseInt(a.split("'")[1] || "0");
      const yearB = parseInt(b.split("'")[1] || "0");
      if (yearA !== yearB) return yearA - yearB;
      const getMonthFromLabel = (label) => {
        const monthName = label.split("'")[0].trim();
        const monthNames = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ];
        return monthNames.indexOf(monthName) + 1;
      };
      return getMonthFromLabel(a) - getMonthFromLabel(b);
    }
    if (a.includes(" - ") && b.includes(" - ") && !a.includes("202") && !b.includes("202") && !a.includes("'") && !b.includes("'")) {
      const getQuarterFromLabel = (label) => {
        const startMonth = label.split(" - ")[0];
        const monthNames = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ];
        const monthIndex = monthNames.indexOf(startMonth);
        return Math.floor(monthIndex / 3) + 1;
      };
      return getQuarterFromLabel(a) - getQuarterFromLabel(b);
    }
    if (a.includes(" - ") && b.includes(" - ") && a.includes("202") && b.includes("202")) {
      const yearA = parseInt(a.split(" ").pop() || "0");
      const yearB = parseInt(b.split(" ").pop() || "0");
      if (yearA !== yearB) return yearA - yearB;
      const getQuarterFromLabel = (label) => {
        const startMonth = label.split(" - ")[0];
        const monthNames = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ];
        const monthIndex = monthNames.indexOf(startMonth);
        return Math.floor(monthIndex / 3) + 1;
      };
      return getQuarterFromLabel(a) - getQuarterFromLabel(b);
    }
    if (a.includes("-") && b.includes("-") && !a.includes(" - ") && !b.includes(" - ") && !a.includes("'") && !b.includes("'")) {
      const [yearA, monthA] = a.split("-");
      const [yearB, monthB] = b.split("-");
      const yearDiff = parseInt(yearA) - parseInt(yearB);
      if (yearDiff !== 0) return yearDiff;
      return parseInt(monthA) - parseInt(monthB);
    }
    return a.localeCompare(b);
  });
};
